import { useContext } from "react";
import LanguageContext from "./LanguageContext";

export default function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("LanguageProvider is required.");
  return context;
}
